module.exports = __webpack_public_path__ + "static/media/insta-btm2.da4ad889.jpg";